import { FC } from "react"
import { Container, Typography } from "@mui/material"
import { useTitle } from "@/core/hooks"
import { BindingsTable } from "../components/tables"
import { WorkflowStepper } from "../components/stepper/workflowStepper"

export const BindingsPage: FC = () => {
  useTitle("Привязки шаблонов")
  return (
    <Container maxWidth={false}>
      <WorkflowStepper />
      <Typography variant="h5" mb={2}>
        Привязки шаблонов
      </Typography>
      <BindingsTable />
    </Container>
  )
}
